<template>
  <div v-if="isWarnDeposit" class="margin-left-5" style="display: inline-flex;">
    <span class="warn-deposit">
      <b-input-group size="md" prepend="デポジット残">
        <b-input class="group-label_8" :value="dispDeposit"/>
      </b-input-group>
    </span>
    <span class="warn-deposit margin-left">
      <b-input-group size="md" variant="info" class="margin-left" prepend="最低預入額">
        <b-input class="group-label_6" :value="dispRequireDeposit"/>
      </b-input-group>
    </span>
  </div>
  <div v-else class="margin-left-10" style="display: inline-flex;">
    <span class="">
      <b-input-group size="md" prepend="デポジット残">
        <b-input class="group-label_8" :value="dispDeposit"/>
      </b-input-group>
    </span>
    <span class="margin-left">
      <b-input-group size="md" variant="info" class="margin-left" prepend="最低預入額">
        <b-input class="group-label_6" :value="dispRequireDeposit"/>
      </b-input-group>
    </span>
  </div>
</template>

<script>
import Vue from 'vue';
import BaseComponent from '@/components/BaseComponent';
import * as utility from '@/utility';

export default {
  mixins: [BaseComponent],
  props: {
    deposit: { default: 0},
    requireDeposit: { default: 0},
    fnumShipping: { default: 0},
    isWarnDeposit: { default: false}
  },
  computed: {
    dispDeposit() {
      return this.formatPrice(this.deposit);
    },
    dispRequireDeposit() {
      return this.formatPrice(this.requireDeposit);
    },
    dispFnumShipping() {
      return this.fnumShipping + '回';
    },
  },
};
</script>

<style>
.component-top-margin-half {
  margin-top: 0.5rem;
}
.margin-left {
    margin-left: 1rem;
}
.margin-left-10 {
    margin-left: 10rem;
}
.group-label_4 {
  pointer-events: none;
  width: 4rem!important;
  text-align: right;
}
.group-label_6 {
  pointer-events: none;
  width: 6rem!important;
  text-align: right;
}
.group-label_8 {
  pointer-events: none;
  width: 8rem!important;
  text-align: right;
}
.warn-deposit .input-group-text{
  background-color: red;
  color: white;
  border-color: red;
}
.warn-deposit .form-control{
  border-color: red;
}
</style>